<template>
  <div class="home">
    <navbar :is-active="1"></navbar>
    <div class="body">
      <CommercialSidebar active="descuentos" />
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Descuentos / <span>Nuevo descuento</span></h2>
        </div>
        <div class="page__subtitle">
          <h3>Información del descuento</h3>
        </div>
        <section class="page__filters">
          <div class="input">
            <p>Código de descuento</p>
            <input type="text" v-model="discount_code" maxlength="10" @keypress="onlynumber(e)">
          </div>
          <div class="input">
            <p>Nombre de descuento</p>
            <input type="text" v-model="discount_name">
          </div>
          <div class="input">
            <p>Fecha inicio</p>
            <input type="date" placeholder="Fecha de nacimiento" v-model="discount_f_inicio" style="outline:none; width: 100%">
          </div>
          <div class="input">
            <p>Fecha fin</p>
            <input type="date" placeholder="Fecha de nacimiento" v-model="discount_f_fin" style="outline:none; width: 100%">
          </div>
          <div class="input">
            <p>Tipo de descuento</p>
            <select v-model="discount_type">
              <option disabled value="">Seleccionar</option>
              <option value="1" >Monto</option>
              <option value="2" >Porcentaje</option>
            </select>
          </div>
          <div class="input" v-if="discount_type==='1'">
            <p>Monto</p>
            <div style="display: flex; justify-content: space-around;">
              <p>S/.</p>
              <input type="text" v-model="discount_amount">
            </div>
          </div>
          <div class="input" v-else>
            <p>Proncetaje</p>
            <div style="display: flex; justify-content: space-around;">
              <p> % </p>
              <input type="text" v-model="discount_amount"  maxlength="3" @keypress="onlynumber(e)">
            </div>
          </div>
          <div class="input" style="background: #e7e7e7;">
            <p>Fecha de Registro</p>
            <span>{{ hoy }}</span>
          </div>
          <div class="input" style="background: #e7e7e7;">
            <p>Fecha de Actualización</p>
            <span>-</span>
          </div>
        </section>

        <div class="page__subtitle">
          <h3>Definición de precios</h3>
        </div>
        <section class="page__filters" style="align-items: center; display: flex; flex-direction: row; justify-content: space-between;">
          <div class="input" style="align-items: center; display: flex; flex-direction: row; justify-content: space-between;">
            <input type="text" v-model="search_product" placeholder="Buscar nombre de producto">
            <i class="fas fa-search"></i>
          </div>
          <div class="lista_productos__buttons">
            <button style="background: #32ba7c;" @click="openModal">
              <span>Agregar</span>
              <i class="fas fa-plus-circle"></i>
            </button>

            <!-- vue modal -->
            <vue-final-modal v-model="showModal"  classes="modal-container" content-class="modal-content">
              <h2 style="text-align: center">{{ titulo }}</h2>
              <br>
              <div id="div_branch_office">
                <div class="page__filters" style="flex-wrap: nowrap !important;">
                  <div class="input">
                    <input
                        type="text"
                        v-model="branch_code"
                        placeholder="Código"
                        @keyup="search"
                    />
                  </div>
                  <div class="input">
                    <input
                        type="text"
                        v-model="branch_name"
                        placeholder="Nombre"
                        @keyup="search"
                    />
                  </div>
                  <p @click="clean_filters()" class="clean_filter">Limpiar Filtros</p>
                </div>
                <div class="page__table">
                  <div class="table-headers">
                    <p v-for="{ label } of columns" :key="label">{{ label }}</p>
<!--                    <p>Acción</p>-->
                  </div>
                  <div class="table-body">
                    <div v-for="branch of branchoffice" :key="branch.id">
                      <form>
                        <div class="data">
                          <p @click="getProducts(branch.id)">{{ codeFormat(branch.branch_code) }}</p>
                          <p>{{ branch.branch_name }}</p>
                          <p>{{ branch.branch_nickname }}</p>
                          <p>{{ branch.branch_direction }}</p>
                          <p>{{ branch.branch_reference }}</p>
<!--                          <p><input type="checkbox" :name="'product'+branch.branch_code" @click="saveSucursal($event, branch)"></p>-->
                        </div>
                      </form>
                    </div>
                    <div style="text-align: center;" v-if="sucursal_empty">
                      <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
                    </div>
                  </div>
                </div>
                <br>
                <div class="page__pagination">
                  <Pagination
                      :data="sucursal_pagination"
                      v-on:changePage="handleClickInSucursal"
                  />
                </div>
                <br>
                <section class="page__actions">
                  <button @click="this.showModal = false">
                    <span>Cancelar</span>
                    <i class="fa fa-times-circle"></i>
                  </button>
                  <button @click="saveSucursalProducto">
                    <span>Guardar</span>
                    <i class="fa fa-circle-check"></i>
                  </button>
                </section>
              </div>

              <div id="div_products" style="display: none">
                <div class="page__filters" style="flex-wrap: nowrap !important;">
                  <div class="input">
                    <input
                        type="text"
                        v-model="product_code"
                        placeholder="Código"
                        @keyup="searchProducts"
                    />
                  </div>
                  <div class="input">
                    <input
                        type="text"
                        v-model="product_name"
                        placeholder="Nombre"
                        @keyup="searchProducts"
                    />
                  </div>
                  <p @click="clean_filters2()" class="clean_filter">Limpiar Filtros</p>
                
                </div>
                <div class="page__table">
                  <div class="table-headers">
                    <p>Código</p>
                    <p>Nombre</p>
                    <p>Descripción</p>
                    <p>Acción</p>
                  </div>
                    <div class="table-body">
                      <div v-for="product of products" :key="product.code">
                        <div class="data">
                          <p>{{ codeFormat(product.product_code) }}</p>
                          <p>{{ product.product_name }}</p>
                          <p>{{ product.product_descripcion }}</p>
                          <p><input type="checkbox" :name="'product'+product.code" @click="saveProducto($event, product)" :checked="isCheckedProducts(product)"></p>
                        </div>
                      </div>
                      <div style="text-align: center;" v-if="product_empty">
                        <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
                      </div>
                    </div>
                </div>
                <br>
                <div class="page__pagination">
                  <Pagination
                      :data="producto_pagination"
                      v-on:changePage="handleClickInProducto"
                  />
                </div>
                <br>
                <section class="page__actions">
                  <button @click="back">
                    <span>Atras</span>
                    <i class="fa-solid fa-arrow-left"></i>
                  </button>
                  <button @click="saveSucursalProducto">
                    <span>Guardar</span>
                    <i class="fa fa-circle-check"></i>
                  </button>
                </section>
              </div>
            </vue-final-modal>
            <!-- vue modal -->
          </div>
          <div class="page__table">
            <div class="table-headers">
              <p>Código de tienda</p>
              <p>Nombre de sucursal</p>
              <p>Código de producto</p>
              <p>Nombre de producto</p>
              <p>Acción</p>
            </div>
            <div class="table-body">
              <div v-for="valor of sucursal_productos">
                <div class="data">
                  <p>{{ codeFormat(valor.branch_code) }}</p>
                  <p>{{ valor.branch_name }}</p>
                  <p>{{ codeFormat(valor.product_code) }}</p>
                  <p>{{ valor.product_name }}</p>
                  <p>
                    <svg @click="deleteProduct(valor)" xmlns="http://www.w3.org/2000/svg" class="h-1 w-1 button_delete" viewBox="0 0 20 20" fill="red">
                      <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                    </svg>
                  </p>
                </div>
              </div>
            </div>
            <div style="text-align: center;" v-if="empty_searchAgregado">
              <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
            </div>
          </div>
        </section>

        <section class="page__actions">
          <button @click="exitDiscount()">
            <span>Cancelar</span>
            <i class="fa fa-times-circle"></i>
          </button>
          <button @click="saveDiscount()">
            <span>Guardar</span>
            <i class="fa fa-circle-check"></i>
          </button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import axios from "axios";
import { $vfm, VueFinalModal, ModalsContainer } from 'vue-final-modal'
import { codeFormat } from '@/utils/formats'
import Pagination from '@/components/Pagination.vue'
import OpenArrow from '@/components/OpenArrow.vue'
import CommercialSidebar from '@/components/CommercialSidebar.vue'

export default {
  name: 'ClientAddDiscount',
  components: {
    Navbar,
    VueFinalModal,
    ModalsContainer,
    Pagination,
    OpenArrow,
    CommercialSidebar
  },
  data() {
    return {
      hoy : new Date().toISOString().slice(0,10).split('-').reverse().join('-'),
      role: localStorage.getItem('role'),
      discount_name: '',
      search_product: '',
      discount_code: '',
      discount_amount: '',
      discount_type: '',
      discount_f_inicio: '',
      discount_f_fin: '',
      showModal: false,
      branchoffice: '',
      products: [],
      sucursales_check: [],
      productos_check: [],
      sucursal_productos: [],
      pagination: '',
      titulo : '',
      product_empty: false,
      sucursal_empty: false,
      sucursal_pagination: [],
      producto_pagination: [],
      empty_searchAgregado: [],
      id_sucursal_seleccionado: null,
      branch_code: '',
      branch_name: '',
      branch_status: '',
      product_code: '',
      product_name: '',
      columns: [
        {
          label: 'Código',
          field: 'branch_code',
          dataFormat: this.codeFormat
        },
        { label: 'Nombre', field: 'branch_name' },
        { label: 'Alias', field: 'branch_nickname' },
        { label: 'Dirección', field: 'branch_direction' },
        { label: 'Referencia', field: 'branch_reference' },
      ],
    }
  },
  created() {
    this.company_name = localStorage.getItem('company_name');
    if (!localStorage.getItem('token')) {
      this.$router.push('/login')
    }
  },
  computed: {
    sucursal_productos: function () {
      let listado = this.sucursal_productos.filter((item) =>
          item.product_name
              .toLowerCase()
              .includes(this.search_product.toLowerCase())
      );
      this.empty_searchAgregado = (listado.length === 0)
      return listado
    },
  },
  methods:{
    onlynumber(evt){
      evt = (evt) ? evt : window.event
      const charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    backCompany(){
      this.$router.push('/comercial')
    },
    clean_filters(){
      this.branch_code = ''
      this.branch_name = ''
      this.getSucursales()
    },
    clean_filters2(){
      this.product_code = ''
      this.product_name = ''
      this.getProducts(this.id_sucursal_seleccionado)
    },
    deleteProduct(prod) {
      this.productos_check.splice(prod,1)
      this.sucursal_productos.splice(prod,1)
      // this.productos_check = this.productos_check.filter((item) => item !== id)
      //
      // for (var i = 0; i < this.searchAgregado.length; i++) {
      //   if (this.searchAgregado[i].id === id.id) {
      //     this.searchAgregado.splice(i, 1);
      //   }
      // }
      // if (this.searchAgregado.length === 0){
      //   this.empty_searchAgregado = true
      // }
    },
    search: function() {
      clearTimeout(this.timeout);
      var self = this;
      this.timeout = setTimeout(function () {
        let paramSearch = {
          branch_code: self.branch_code,
          branch_nickname: self.branch_nickname,
          branch_name: self.branch_name,
          branch_pro_id: self.branch_pro_id,
          branch_dis_id: self.branch_dis_id,
          branch_dep_id: self.branch_dep_id,
          branch_status: self.branch_status,
        }
        this.getSucursales(1, paramSearch)
      }.bind(this), 500);
    },
    searchProducts: function() {
      clearTimeout(this.timeout);
      var self = this;
      this.timeout = setTimeout(function () {
        let paramSearch = {
          product_code: self.product_code,
          product_name: self.product_name,
        }
        this.getProducts(self.id_sucursal_seleccionado, 1, paramSearch)
      }.bind(this), 500);
    },
    isCheckedProducts(data){
      return (this.productos_check.filter((item) => item.id === data.id && item.suc_id === data.suc_id).length === 1);
    },
    codeFormat,
    handleClickInSucursal: function(page) {
      this.getSucursales(page)
    },
    handleClickInProducto: function(page) {
      this.getProducts(this.id_sucursal_seleccionado, page)
    },
    saveSucursal(event, id){
              axios.post('general/branchoffice/products', {
                page: 1,
                id: id,
                product_status: 1
              }).then( res => {
                if (res.data.data.total > 0){
                  if (event.target.checked){
                    res.data.data.data.forEach(itemProd => {
                      this.productos_check.push(itemProd)
                    })
                  }else{
                    res.data.data.data.forEach(itemProd => {
                      this.productos_check.splice(itemProd,1)
                    })
                  }

                }
              })
    },
    saveProducto(event, id){
      if (event.target.checked){
        this.productos_check.push(id)
      }else{
        this.productos_check = this.productos_check.filter((item) => item !== id)
      }
    },
    back(){
      this.getSucursales()
      this.titulo = 'Lista de Sucursales'
      var div_branch_office = document.getElementById('div_branch_office');
      div_branch_office.style.display = 'contents'
      var div_products = document.getElementById('div_products');
      div_products.style.display = 'none'
    },
    async getProducts(id, page = 1, paramSearch = {}){
      this.id_sucursal_seleccionado = id
      var tempProduct = ''
      this.sucursal_productos.forEach((item,index) =>{
        if(index===0){
          tempProduct = item.id.toString()+':'+item.suc_id.toString()
        }else {
          tempProduct = tempProduct + ','+  item.id.toString()+':'+item.suc_id.toString()
        }
      })

      await axios.post('general/branchoffice/products', {
        page: page,
        id: id,
        product_code: ( typeof paramSearch.product_code === 'undefined' || paramSearch.product_code === '' ) ? null : parseInt(paramSearch.product_code),
        product_name: paramSearch.product_name,
        product_status: 1,
        not: (tempProduct) ? tempProduct : null,
      }).then( res => {
        if (res.data.data.total > 0){
          this.products = res.data.data.data
          this.producto_pagination = res.data.data
          this.product_empty = false
        }else{
          this.products = {}
          this.producto_pagination = {}
          this.product_empty = true
        }
      })
      this.titulo = 'Lista de Productos'
      var div_branch_office = document.getElementById('div_branch_office');
      div_branch_office.style.display = 'none'
      var div_products = document.getElementById('div_products');
      div_products.style.display = 'contents'
    },
    saveSucursalProducto(){
      this.sucursal_productos = []
      this.showModal = false
      this.productos_check.forEach(itemGeneral=> {
        this.sucursal_productos.push(itemGeneral)
      })
    },
    async getSucursales(page = 1, paramSearch = {}) {
      await axios.get('general/branchoffice', {params: {
          page: page,
          branch_company_id:localStorage.getItem('company_id'),
          branch_code: ( typeof paramSearch.branch_code === 'undefined' || paramSearch.branch_code === '' ) ? null : parseInt(paramSearch.branch_code),
          branch_name: paramSearch.branch_name,
          branch_status: 1,
        }}).then( res => {
        if (res.data.data.total > 0){
          this.branchoffice = res.data.data.data
          this.sucursal_pagination = res.data.data
          this.sucursal_empty = false
        }else{
          this.branchoffice = {}
          this.sucursal_pagination = {}
          this.sucursal_empty = true
        }
      })
    },
    openModal(){
      this.getSucursales()
      this.showModal = true
      this.titulo = 'Lista de Sucursales'
      var div_branch_office = document.getElementById('div_branch_office');
      div_branch_office.style.display = 'contents'
      var div_products = document.getElementById('div_products');
      div_products.style.display = 'none'
    },
    async saveDiscount(){
      try {
        const response = await axios.post('general/discount', {
          product_path: this.file,
          discount_name: this.discount_name,
          discount_code: this.discount_code,
          discount_amount: this.discount_amount,
          discount_type: this.discount_type,
          discount_f_inicio: this.discount_f_inicio,
          discount_f_fin: this.discount_f_fin,
          discount_company_id: localStorage.getItem('company_id'),
          products: this.productos_check
        })
        if(response.status === 200){
          this.$swal({
            position: 'center',
            icon: 'success',
            title: 'Descuento creado correctamente',
            showConfirmButton: false,
            timer: 2000
          })
          this.$router.push('/discount')
        }
      } catch (error) {
        console.log(error)
        this.$swal({
          position: 'center',
          icon: 'error',
          title: 'Completar los datos correctamente',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },
    exitDiscount(){
      this.$router.push('/discount')
    }
  },
}


</script>

<style scoped>
#input_file {
  cursor: pointer;
  margin: 0;
  opacity: 0;
  outline: 0 none;
  padding: 0;
  position: absolute;
}
/*------NAVBAR------*/
.home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Readex Pro', sans-serif;
}

.home .navbar {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
}

.home .navbar__left {
  width: 10%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home .navbar__left img {
  width: 130px;
}

.home .navbar__center {
  width: 70%;
  height: 100%;
}

.home .navbar__center ul{
  width: 100%;
  height: 100%;
  display: flex;
  list-style: none;
  display: flex;
  justify-content: flex-start;
}
.home .navbar__center ul li {
  text-decoration: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  cursor: pointer;
}

.home .navbar__center ul li::before {
  content: '';
  position: absolute;
  bottom: 0;
  width: 0;
  height: 4px;
  background-color: #ff3128;
  transition: .3s ease;
}
.home .navbar__center ul li:hover {
  color: #ff3128;
}
.home .navbar__center ul li:hover::before {
  width: 100%;
}

.home .navbar__right {
  display: flex;
  width: 20%;
}
.home .navbar__right .profile {
  display: flex;
  width: 100%;
  height: 100%;
}

.home .navbar__right .profile__detail{
  width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5px;
}
.home .navbar__right .profile__detail p {
  margin: 0;
}
.home .navbar__right .profile__detail span {
  color: #938f8f;
  font-weight: 300;

}

.home .navbar__right .profile__icon,
.home .navbar__right .profile__logout {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #ff3128;
  cursor: pointer;
}
/*------NAVBAR------*/

/*-------------------------*/
a:hover {
  text-decoration: none;
}
/*-------------------------*/

/*------BODY------*/

.body {
  width: 100%;
  height: 600px;
  display: flex;
}
.body__containt  {
  height: calc(100vh - 120px);
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
}
.body__sidebar {
  width: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.body__sidebar .floating-icon {
  position: absolute;
  right: -15px;
  top: 30px;
  color: #ff3128;
  font-size: 30px;
}

.body__sidebar .title {
  width: 100%;
  height: 140px;
  border-bottom: 1px solid #b6b6b6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.body__sidebar .title__icon {
  color: #ff3128;
  font-size: 20px;
}
.body__sidebar .title__text {
  margin: 0 10px;

}

.body__sidebar .title__text h2 {
  font-size: 20px;
  margin: 0;
}
.body__sidebar .title__text p {
  margin: 0;
  font-weight: 300;
}

.body__sidebar .tabs {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 140px);
  padding-top: 5px;
}

.body__sidebar .tabs .tab {
  width: 90%;
  height: 70px;
  border-radius: 10px;
  color: #707070;
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.3 ease;
}
.body__sidebar .tabs .tab:hover,
.body__sidebar .tabs .tab.active {
  color: #ff3128;
  background: #ffeeed;
}

.body__sidebar .tabs .tab__icon {
  font-size: 20px;
  margin-right: 10px;
}

.body__sidebar .tabs .tab__text p{
  margin: 0;
  font-weight: 600;
}
/*----------------------------*/
/*----------------------------*/
/*----------------------------*/
.body__containt {
  height: fit-content;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  overflow-y: scroll;
}
.body__containt .page__subtitle,
.body__containt .page__title {
  width: 100%;
  margin-bottom: 20px;
}

.body__containt .page__title h2 {
  font-weight: 600;
  color: #000;
  font-size: 25px;
}
.body__containt .page__title h2 span {
  color: #ff3128;
}
.body__containt .page__subtitle h3  {
  color: #ff3128;
  font-weight: 600;
  font-size: 20px;
}

/*-----FILTERS------*/

.body__containt .page__filters {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 40px;
}

.body__containt .page__filters .input {
  width: 300px;
  border-radius: 10px;
  border: 1px solid #938f8f;
  display: flex;
  flex-direction: column;
  padding: 7px 15px;
  transition: 0.4s ease;

}

.body__containt .page__filters .input:hover {
  box-shadow: 10px 15px 15px rgba(0, 0, 0, 0.05);
}
.body__containt .page__filters .input span {
  font-size: 15px;
  color: #938f8f;
}
.body__containt .page__filters .input p {
  margin: 0;
}

.page__filters input, select, textarea{
  outline:none;
  border: none;
  background: white;
}

/*-----PRODUCT------*/
.page__product {
  width: 100%;
  display: flex;
  padding-bottom: 50px;
  border-bottom: 1px solid #938f8f;
}

.page__product .product__image,
.page__product .product__buttons {
  /* width: 50%; */
  display: flex;
  align-items: center;
}
.page__product .product__image {
  width: 400px;
  justify-content: center;
  border-radius: 10px;
  overflow: hidden;
}

.page__product .product__image img {
  width: 100%;
  object-fit: cover;
  transition: 1s ease;
}
.page__product .product__image img:hover {
  transform: scale(1.1) rotate(1deg);
}
.page__product .product__buttons {
  width: 500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.page__actions button,
.page__product .product__buttons button {
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border: none;
  border-radius: 15px;
  color: #fff;
  transition: 0.4s ease;
}
.page__actions button:hover,
.page__product .product__buttons button:hover {
  transform: scale(1.1);
}
.page__actions button:nth-child(2),
.page__product .product__buttons button:nth-child(1) {
  background: #32ba7c;
}
.page__product .product__buttons button:nth-child(2) {
  background: #262626;
}
.page__product .product__buttons button:hover:nth-child(2) {
  background: #ff3128;
}

/*------------------------*/
/*------------------------*/
/*------------------------*/

.page__actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 30px 0;
  gap: 20px;
}

.page__actions button:nth-child(1) {
  background: #ff3128;
}

/*------BODY------*/
.body__containt .page__table {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
}
.body__containt .page__table .table-headers {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-evenly;
  border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-headers p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  white-space: nowrap;
}
.body__containt .page__table .table-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-body .data {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.body__containt .page__table .table-body .data p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  margin: 10px 0;
}
.body__containt .page__table .table-body .data p:nth-child(1) {
  color: #ff3128;
}
.lista_productos__buttons button{
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border: none;
  border-radius: 15px;
  color: #fff;
  transition: 0.4s ease;
}
.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 20px;
  margin-bottom: 0px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 17px;
  left: 2px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
input:checked + .slider {
  background-color: #32ba7c;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}

/*modal*/
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  height: 100%;
  overflow-y: auto;
}
.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
}
.modal__content {
  flex-grow: 1;
  overflow-y: auto;
}
.modal__action {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 1rem 0 0;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
/*check*/
input[type="checkbox"] {
  width: 100%;
  height: 20px;
}
      .body__sidebar.open{
    display: none;
  }


/*-----FILTERS------*/

.body__containt .page__filters {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
}

.body__containt .page__filters .input {
  width: 300px;
  border-radius: 10px;
  border: 1px solid #938f8f;
  display: flex;
  flex-direction: column;
  padding: 7px 15px;
  transition: 0.4s ease;

}

.body__containt .page__filters .input:hover {
  box-shadow: 10px 15px 15px rgba(0, 0, 0, 0.05);
}
.body__containt .page__filters .input:nth-child(2) {

}
/*.body__containt .page__filters .input:nth-last-child(1) {*/
/*  width: 1260px;*/
/*}*/
.body__containt .page__filters .input span {
  font-size: 15px;
  color: #938f8f;
}
.body__containt .page__filters .input p {
  margin: 0;
}

.page__filters input, select, textarea{
  outline:none;
  border: none;
  background: white;
}
.button_delete{
  width: 2rem;
}
.back_company {
  background: #000;
  color: white;
  width: 100%;
  padding-top: 3%;
  padding-left: 10%;
}
</style>
